
import React from 'react';
import {
  Cell, Pie, PieChart, ResponsiveContainer, Tooltip, Legend,
} from 'recharts';
import { CubeJsGraphBase } from './base';


const COLORS = [
  '#4c00d2',
  '#0ede9a',
  '#4ba3ff',
  '#f9d041',
  '#ee4938',
];

export default abstract class PieGraphBase extends CubeJsGraphBase {
    abstract headerKey(): string

    abstract dataKey(): string

    queryRender(props) {
      // @ts-ignore
      const { resultSet, pivotConfig } = props;

      const headers = resultSet.tableColumns(pivotConfig);
      const headerKeys = headers.map((h) => h.key);
      //   const data = resultSet.tablePivot(pivotConfig);
      const data = props.resultSet.chartPivot();


      const hk = this.headerKey();
      const dk = this.dataKey();

      //   const processedData = data.map((row) => ({
      //     value: Number(row[dk]),
      //     category: row[hk],
      //   }));

      return (
        <>
          <ResponsiveContainer width="100%" aspect={4}>
            <PieChart>
              <Pie
                data={data}
                nameKey="x"
                dataKey={resultSet?.seriesNames()[0]?.key}
                // cx={30}
                fill="#f3f3f3"
                innerRadius="60%"
                label={false}
              >
                {
                  props.resultSet.chartPivot().map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />)
                }
              </Pie>
              <Legend
                align="right"
                height="100"
                width="100"
                layout="vertical"
                iconType="circle"
                wrapperStyle={{ fontSize: '14px' }}
                // formatter={(value, entry, idx) => `${value} (${Number(entry.payload.value).toLocaleString()})`}
              />
              <Tooltip />

            </PieChart>
          </ResponsiveContainer>
        </>
      );
    }
}
